import { atom } from 'recoil';

export const activeButtonState = atom({
  key: 'activeButtonState',
  default: 'day',
});